// extracted by mini-css-extract-plugin
var _1 = "Hg66I";
var _2 = "hL0qC";
export { _1 as "base", _2 as "chart" }
